import React from "react";

const Blog = () => {
  return (
    <div className=" py-20  px-6  xl:px-20" id="blog">
      <h2 className="text-5xl font-Kdam text-center mt-6">My Blog</h2>
      <div className="mt-16 text-4xl text-center text-gray-400">
        Comming Soon...
      </div>
    </div>
  );
};

export default Blog;
